import { QRCodeCanvas } from "qrcode.react"
import React from "react"

import Modal from "@/components/Modal"

import "./style.less"

export interface BroearnWalletModalMethod {
    open(uri: string): void
    close(): void
}

const BroearnWalletModal: React.ForwardRefExoticComponent<
    React.PropsWithoutRef<{}> & React.RefAttributes<BroearnWalletModalMethod>
> = React.forwardRef(({

}, ref) => {
    const [visible, setVisible] = React.useState<boolean>(false)
    const [uri, setUri] = React.useState<string>("")

    React.useImperativeHandle(ref, () => ({
        open(uri) {
            setVisible(true)
            setUri(uri)
        },
        close() {
            setVisible(false)
        }
    }))

    const onCancel = () => {
        setVisible(false)
    }

    return (
        <Modal
            visible={visible}
            onClose={onCancel}
            className="broearnWalletModal"
            width={332}
        >
            <div className="broearn-wallet-title">
                Please scan the code to log in in the Broearn wallet
            </div>
            <QRCodeCanvas
                css={{ margin: "36px auto 30px", borderRadius: "8px" }}
                size={224}
                imageSettings={{
                    width: 40,
                    height: 40,
                    src: require("@/assets/wallet.png"),
                    excavate: true
                }}
                value={uri}
            />
        </Modal>
    )
})

export default BroearnWalletModal
